import React from 'react';
import ReactMarkdown from 'react-markdown';

const Markdown = ({ children, className, inline }) => {
  if (!children) return null;

  if (inline) {
    return (
      <ReactMarkdown components={{ p: 'span' }}>
        {children}
      </ReactMarkdown>
    );
  }

  return (
    <div className={`markdown-content ${className || ''}`}>
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
};

export default Markdown;
